import request from "@/utils/request.js";

// http://180.167.172.122:6405/hz-smart-community/data/analyse/unit/type?regionId=0
// 实有单位 单位类别
export const unitType = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/unit/type",
    params: data || {}
  });
};
// http://180.167.172.122:6405/hz-smart-community/data/analyse/unit/createTime?regionId=0
// 实有单位 运营时间
export const createTime = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/unit/createTime",
    params: data || {}
  });
};
// http://180.167.172.122:6405/hz-smart-community/data/analyse/unit/industryType?regionId=0
// 实有单位 行业类型
export const industryType = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/unit/industryType",
    params: data || {}
  });
};

// http://180.167.172.122:6405/hz-smart-community/data/analyse/unit/keyunit?regionId=0
// 实有单位 重点单位
export const keyunit = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/unit/keyunit",
    params: data || {}
  });
};
// http://180.167.172.122:6405/hz-smart-community/data/analyse/unit/economicType?regionId=0
// 实有单位 经济类型
export const economicType = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/unit/economicType",
    params: data || {}
  });
};
// http://180.167.172.122:6405/hz-smart-community/data/analyse/unit/region?regionId=0&type=0
// 实有单位 经济类型
export const unitRegion = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/unit/region",
    params: data || {}
  });
};
// http://180.167.172.122:6405/hz-smart-community/data/analyse/unit/count?regionId=0
// 实有单位 单位总数
export const unitCount = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/unit/count",
    params: data || {}
  });
};





// 实有房屋
export const securitysave = data => {
  return request({
    url: "/api/hz-smart-community/security/facilities/save",
    data: data || {},
    method: "POST"
  });
};

